import { Routes } from '@angular/router';
import { verifiedGuard } from './guards/verified.guard';
import { PageNotFound } from './pages/page-not-found/page-not-found';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'tableau-de-bord',
        pathMatch: 'full'
    },
    {
        path: 'tableau-de-bord',
        loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.Dashboard),
        title: 'Tableau de bord',
        canActivate: [verifiedGuard]
    },
    {
        path: 'activites',
        loadComponent: () => import('./pages/activity/activity').then(m => m.Activity),
        loadChildren: () => import('./pages/activity/activity.routes').then(m => m.activityRoutes),
        title: 'Activités',
        canActivate: [verifiedGuard]
    },
    {
        path: 'statistiques',
        loadComponent: () => import('./pages/statistic/statistic').then(m => m.Statistic),
        title: 'Statistiques',
        canActivate: [verifiedGuard]
    },
    {
        path: 'billing',
        loadComponent: () => import('./pages/billing/billing').then(m => m.Billing),
        title: 'Facturation',
        canActivate: [verifiedGuard]
    },
    {
        path: 'avis',
        loadComponent: () => import('./pages/review/review').then(m => m.Review),
        title: 'Avis',
        canActivate: [verifiedGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./components/activity-review-list/activity-review-list').then(m => m.ActivityReviewList)
            },
            {
                path: ':activityId/commentaires',
                loadComponent: () => import('./components/activity-review-comment-list/activity-review-comment-list').then(m => m.ActivityReviewCommentList),
                title: 'Commentaires'
            }
        ]
    },
    {
        path: 'notifications',
        loadComponent: () => import('./pages/notification/notification').then(m => m.Notification),
        title: 'Notifications',
        canActivate: [verifiedGuard],
        children: [
            { path: '', redirectTo: 'all', pathMatch: 'full' },
            {
                path: 'all',
                loadComponent: () => import('./pages/notification/all/all').then(m => m.All),
                title: 'Tous'
            },
            {
                path: 'bookings',
                loadComponent: () => import('./pages/notification/bookings/bookings').then(m => m.Bookings),
                title: 'Réservations'
            },
            {
                path: 'reviews',
                loadComponent: () => import('./pages/notification/reviews/reviews').then(m => m.Reviews),
                title: 'Avis'
            },
            {
                path: 'support',
                loadComponent: () => import('./pages/notification/support/support').then(m => m.Support),
                title: 'Support'
            },
        ]
    },
    {
        path: 'reservations',
        loadComponent: () => import('./pages/booking/booking').then(m => m.Booking),
        title: 'Réservation',
        canActivate: [verifiedGuard]
    },
    {
        path: 'reservations/:slotId',
        loadComponent: () => import('./pages/booking/booking-detail/booking-detail').then(m => m.BookingDetail),
        title: 'Réservation',
        canActivate: [verifiedGuard]
    },
    {
        path: 'parametre',
        loadComponent: () => import('./pages/parameter/parameter').then(m => m.Parameter),
        title: 'Paramètre',
        children: [
            { path: '', redirectTo: 'entreprise', pathMatch: 'full' },
            {
                path: 'entreprise',
                loadComponent: () => import('./pages/parameter/company/company').then(m => m.Company),
                title: 'Entreprise'
            },
            {
                path: 'profil',
                loadComponent: () => import('./pages/parameter/profile/profile').then(m => m.Profile),
                title: 'Profil'
            },
            {
                path: 'representative',
                loadComponent: () => import('./pages/parameter/representative/representative').then(m => m.Representative),
                title: 'Représentant'
            },
            {
                path: 'booking',
                loadComponent: () => import('./pages/parameter/booking/booking').then(m => m.Booking),
                title: 'Réservations'
            },
            {
                path: 'notification',
                loadComponent: () => import('./pages/parameter/notification/notification').then(m => m.Notification),
                title: 'Notification'
            },
            {
                path: 'compte',
                loadComponent: () => import('./pages/parameter/account/account').then(m => m.Account),
                title: 'Compte'
            },
            {
                path: 'compte/a-propos',
                loadComponent: () => import('./pages/parameter/account/about/about').then(m => m.About),
                title: 'À propos'
            }
        ]
    },
    {
        path: 'verify-otp',
        loadComponent: () => import('./pages/otp/otp').then(m => m.Otp),
        title: 'Vérification du code OTP',
    },
    {
        path: 'onboarding/refresh',
        loadComponent: () => import('./pages/onboarding-refresh/onboarding-refresh').then(m => m.OnboardingRefresh),
        title: 'Onboarding Stripe',
    },
    {
        path: 'affiche-arrivee/:placeId',
        loadComponent: () => import('./pages/arrival-poster/arrival-poster').then(m => m.ArrivalPoster),
        title: "Affiche d'arrivée",
        canActivate: [verifiedGuard],
        data: { hideLayout: true }
    },
    { path: '**', component: PageNotFound },
];
